import type { FluxErrorEntityErrorCodes } from '../types.js';

export const PermissionErrorCodes = {
  PermissionNotFound: {
    code: 'permission/not-found',
    message: 'Permissão não encontrada.',
    explanation: 'A permissão que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'permission'>;
